import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, Button, Box, CircularProgress, Grid } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { GET_DASHBOARD_INVENTORY_LIST } from '../../../common/URLs';
import { toast } from 'react-toastify';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { loaderService } from '../../../common/custom-loader/loader-service';
import axios from "axios";

const BundleSelection = ({ open, selectedNSTR, pickupQuantity, setPickupQuantity, onClose, onSubmit, selectedHeap }) => {
    const [heapData, setHeapData] = useState([]);

    useEffect(() => {
        if (open) {
            setPickupQuantity(pickupQuantity || '');
            loaderService.showLoader();
            axios.post(GET_DASHBOARD_INVENTORY_LIST, {
                "stakeHolderType": selectedNSTR?.sourceStakeholderType,
                "stakeHolderUrn": selectedNSTR?.sourceStakeholderUrn,
                "materialType": selectedNSTR?.materialType,
                "inventoryCategory": "Unrestricted",
            },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null)
                .then(response => {
                    const data = response.data.inventories.map(item => {
                        const prefill = selectedHeap?.find(h => h.id === item.id);
                        return {
                            ...item,
                            pickupQty: prefill ? prefill.pickupQty : '',
                        };
                    });
                    setHeapData(data);
                    loaderService.hideLoader();
                })
                .catch(err => console.error('API Error:', err),
                    loaderService.hideLoader()
                )
        }
    }, [open, pickupQuantity, selectedHeap]);

    const computeQuantities = () => {
        const totalBalanceQuantity = heapData?.reduce((accumulator, currentItem) => {
            return accumulator + currentItem.weight;
        }, 0)
        if (totalBalanceQuantity < pickupQuantity) {
            toast.error('Insufficient weight from below bundles to meet the required pick-up quantity!');
        }
        else {
            let remaining = Number(pickupQuantity);
            if (isNaN(remaining) || remaining <= 0) return;
            const updated = heapData.map((heap) => {
                if (remaining <= 0 || heap.weight <= 0) return { ...heap, pickupQty: 0 };
                const assignQty = Math.min(heap.weight, remaining);
                remaining -= assignQty;
                return { ...heap, pickupQty: parseFloat(assignQty.toFixed(4)) };
            });
            setHeapData(updated);
        }

    };

    const handleCancel = () => {
        setPickupQuantity('');
        const reset = heapData.map(h => ({ ...h, pickupQty: 0 }));
        setHeapData(reset);
        onClose();
    };

    const handleSubmit = () => {
        const selected = heapData.filter(h => h.pickupQty > 0);
        onSubmit({ heaps: selected, pickupQty: Number(pickupQuantity) });
        onClose();
    };

    const columns = [
        { field: 'bundleId', headerName: 'Bundle ID', flex: 1 },
        { field: 'weight', headerName: 'Weight(MT)', flex: 1 },
        { field: 'pickupQty', headerName: 'Pick-up Quantity(MT)', flex: 1 },
    ];

    return (
        <Dialog open={open} fullWidth maxWidth="md" onClose={onClose}>
            <DialogTitle>Bundle Details</DialogTitle>
            <DialogContent>
                <Grid container spacing={1} direction="row" mt={1}>
                    <Grid item xs={8} lg={6}>
                        <TextField
                            label="Pick-up Quantity (MT)"
                            type="number"
                            value={pickupQuantity}
                            onChange={(e) => setPickupQuantity(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={4} lg={6}>
                        <Button style={{ float: "right" }}
                            variant="contained"
                            onClick={computeQuantities}

                        >
                            Compute Quantity from below bundles
                        </Button>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <Box sx={{ height: 400, width: '100%' }}>
                            <DataGrid
                                rows={heapData}
                                columns={columns}
                                pageSize={5}
                                disableSelectionOnClick
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Box textAlign="right" mt={2}>
                    <Button variant="outlined" onClick={handleCancel} sx={{ mr: 1 }}>
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={handleSubmit}>
                        Submit
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default BundleSelection;